import { SVGProps } from "react";
import { PedagogueLockup } from "@pedagogue/ui-core";

const LogoImg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={121} height={24} overflow="visible" {...props}>
    <foreignObject width="100%" height="100%" overflow="visible">
      <PedagogueLockup size={24} variant="default" />
    </foreignObject>
  </svg>
);
export default LogoImg;
